module.exports = __webpack_public_path__ + "static/media/inr_icon_anim.59697931.usdz";